import { render, staticRenderFns } from "./game-task-card.vue?vue&type=template&id=28b8cd44&scoped=true&lang=pug&"
import script from "./game-task-card.vue?vue&type=script&lang=js&"
export * from "./game-task-card.vue?vue&type=script&lang=js&"
import style0 from "./game-task-card.vue?vue&type=style&index=0&id=28b8cd44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8cd44",
  null
  
)

export default component.exports